import {withPlatform} from '@lib/PlatformedRegistry';
import {Header as desktop} from './Header@desktop';
export * from './Header.typings';
export var Header = withPlatform({
  desktop: desktop
});
